
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { JobDetailedData, JobDetailedStop } from '@/models/jobDetailed';
import TDatepickerDateField from '@/components/fields/TDatepickerDateField.vue';
import TDatepickerTimeField from '@/components/fields/TDatepickerTimeField.vue';
import { getIsDatesError } from '@/helpers/booking';
import { format, utcToZonedTime } from 'date-fns-tz';
import { statesTimeZonesList, timeZoneDefault } from '@/utils/PortalConstants';

@Component({
  components: {
    TDatepickerDateField,
    TDatepickerTimeField,
  },
})
export default class DateTimesFieldset extends Vue {
  @Prop(Object) public value: JobDetailedStop;
  @Prop(Object) public detailedJob: JobDetailedData;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public isDatesError = false;

  get jobStop() {
    return this.value;
  }

  set jobStop(value) {
    this.$emit('input', value);
  }

  /**
   * Changing the `time_latest` date (day, month and year) without changing
   * the time and time zone to synchronize with `time_earliest`
   */
  public timeEarliestChanged(val) {
    const stopTimeZone = statesTimeZonesList[this.jobStop.state]?.timezone || timeZoneDefault;
    const formatVal = this.jobStop.time_earliest.slice(0, 'yyyy-MM-dd'.length);

    const earliestYear = parseInt(formatVal.split('-')[0]);
    const earliestMonth = parseInt(formatVal.split('-')[1]);
    const earliestDate = parseInt(formatVal.split('-')[2]);

    let latestDate: Date | number = utcToZonedTime(new Date(this.jobStop.time_latest), stopTimeZone);
    latestDate = new Date(latestDate).setDate(earliestDate);
    latestDate = new Date(latestDate).setMonth(earliestMonth - 1);
    latestDate = new Date(latestDate).setFullYear(earliestYear);

    this.jobStop.time_latest = format(new Date(latestDate), "yyyy-MM-dd'T'HH:mm:ssxxx", { timeZone: stopTimeZone });
  }

  @Watch('detailedJob.stops', { deep: true, immediate: true })
  private isErrorWatcher() {
    this.isDatesError = false;
    if (!this.detailedJob) {
      return;
    }
    this.isDatesError = getIsDatesError(this.detailedJob.stops);
  }
}
